module.exports = __webpack_public_path__ + "img/acelida_mobile.7456e353.png";